var _rect, _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamMenuMercedes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 600,
    viewBox: "0 0 440 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_924)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_924)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_924",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 687.54L777.16 58.466H1268.83L300.331 819.329L-23.587 818.53V687.54Z",
    fill: "url(#paint0_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.122 625.24H777.567L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5869 513.738L368.856 205.431H748.286L-27.8569 815.176L-23.5869 513.738Z",
    fill: "url(#paint2_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.232 817.891L709.245 434.505H1158.22L667.052 820.367L221.232 817.891Z",
    fill: "url(#paint3_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.019 -12.939L160.942 435.703H592.122L1165.49 -14.736L732.019 -12.939Z",
    fill: "url(#paint4_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.593 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint5_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.8 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.8 -10.224Z",
    fill: "url(#paint6_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.623L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint7_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.895 412.49H280.976L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint8_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.8569 815.176L298.789 558.56H735.272L405.923 817.299L-27.8569 815.176Z",
    fill: "url(#paint9_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 369.04H422.944L-34.447 728.37L-23.587 369.04Z",
    fill: "url(#paint10_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.73 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint11_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.944 -121.136L-153.012 331.34V-118.652L422.944 -121.136Z",
    fill: "url(#paint12_linear_3_924)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M2400 0H0V800H2400V0Z",
    fill: "#00A19C"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.323 293.918C144.323 326.087 118.382 352.119 86.3267 352.119C54.2712 352.119 28.3303 326.087 28.3303 293.918C28.3303 261.75 54.2712 235.718 86.3267 235.718C118.382 235.718 144.323 261.75 144.323 293.918ZM86.3267 239.251C56.1247 239.251 31.8511 263.61 31.8511 293.918C31.8511 324.227 56.3098 348.586 86.3267 348.586C116.529 348.586 140.802 324.041 140.802 293.918C140.802 263.61 116.529 239.251 86.3267 239.251Z",
    fill: "url(#paint13_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3267 239.251C56.1248 239.251 31.8511 263.61 31.8511 293.918C31.8511 324.227 56.3098 348.586 86.3267 348.586C116.529 348.586 140.802 324.041 140.802 293.918C140.802 263.61 116.529 239.251 86.3267 239.251ZM86.3267 345.052C58.1621 345.052 35.3718 322.182 35.3718 293.918C35.3718 265.655 58.1621 242.784 86.3267 242.784C114.491 242.784 137.282 265.655 137.282 293.918C137.282 322.182 114.491 345.052 86.3267 345.052Z",
    fill: "url(#paint14_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3267 352.119C118.382 352.119 144.323 326.087 144.323 293.918C144.323 261.75 118.382 235.718 86.3267 235.718C54.2711 235.718 28.3303 261.75 28.3303 293.918C28.3303 326.087 54.2711 352.119 86.3267 352.119ZM86.3267 234.416C118.938 234.416 145.62 261.191 145.62 293.918C145.62 326.645 118.938 353.42 86.3267 353.42C53.7159 353.42 27.0333 326.644 27.0333 293.918C27.0333 261.193 53.7159 234.416 86.3267 234.416Z",
    fill: "url(#paint15_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1094 294.104C31.1094 263.61 55.7532 238.507 86.3254 238.507C116.898 238.507 141.541 263.423 141.541 294.104C141.541 324.598 116.898 349.329 86.3254 349.329C55.7532 349.329 31.1094 324.599 31.1094 294.104ZM48.3416 255.8C38.521 265.655 32.4064 279.229 32.4064 294.104C32.4064 308.98 38.521 322.554 48.1565 332.223C57.977 341.892 71.5034 348.028 86.3267 348.028C101.15 348.028 114.676 342.078 124.312 332.223C134.132 322.554 140.062 308.98 140.062 294.104C140.062 279.229 133.947 265.655 124.312 255.8C114.676 245.944 101.15 239.81 86.3267 239.81C71.5034 239.81 57.977 245.946 48.3416 255.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3266 345.238C72.6152 345.238 59.8305 339.846 50.1951 330.177C40.5596 320.508 35.1866 307.678 35.1866 293.918C35.1866 280.159 40.5596 267.329 50.1951 257.66C59.8305 247.99 72.6152 242.598 86.3266 242.598C100.038 242.598 112.823 247.99 122.458 257.66C132.094 267.329 137.467 280.159 137.467 293.918C137.467 307.678 132.094 320.508 122.458 330.177C112.823 339.846 100.038 345.238 86.3266 345.238ZM86.3266 343.751C99.4828 343.751 112.082 338.545 121.346 329.247C130.797 319.763 135.799 307.305 135.799 294.104C135.799 280.903 130.61 268.258 121.346 258.961C111.896 249.478 99.4815 244.457 86.3266 244.457C73.1718 244.457 60.5709 249.665 51.307 258.961C41.8566 268.072 36.6687 280.716 36.6687 293.918C36.6687 307.121 41.8566 319.765 51.1219 329.061C60.5709 338.545 73.1705 343.751 86.3266 343.751Z",
    fill: "url(#paint16_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.352 318.09C130.425 317.346 94.6638 288.898 94.6638 288.898L86.3267 241.111C85.7714 241.297 85.0297 241.855 84.6595 242.598L78.7299 289.084L41.8567 317.533C41.8567 317.533 41.115 318.463 40.7448 319.02C40.5597 319.392 40.5597 319.95 40.5597 320.508L86.1416 301.728L131.724 320.508C132.094 319.579 131.722 318.649 131.352 318.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6968 295.406L86.3267 303.959L128.203 320.88C129.685 321.625 130.797 321.252 131.909 320.509L87.2534 295.221C87.067 295.034 86.6968 295.22 86.6968 295.406Z",
    fill: "#576065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6969 295.406C86.6969 295.406 89.1058 299.682 91.8848 302.658C95.7757 306.934 100.964 309.91 100.964 309.91L128.201 320.88C129.684 321.625 130.795 321.252 131.907 320.509L87.2522 295.221C87.0671 295.034 86.6969 295.22 86.6969 295.406Z",
    fill: "url(#paint17_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.722 318.835C131.722 318.649 131.537 318.463 131.352 318.09L93.1818 290.014L87.9939 293.361C87.9939 293.361 88.3641 293.547 88.5492 293.361C89.1045 293.175 90.2163 292.99 91.3282 293.361C92.255 293.733 131.722 319.022 131.722 319.022V318.835Z",
    fill: "#A5ABAF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.425 317.162L94.8503 288.898L93.1831 290.014L131.353 318.277C131.167 317.905 130.797 317.533 130.425 317.162Z",
    fill: "#343F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2535 292.617L87.0684 292.803C87.0684 292.803 87.0684 293.174 87.4386 292.988C87.6236 292.803 92.9967 290.014 94.8502 288.898L88.364 244.271C88.1789 242.598 87.4372 241.854 86.1403 241.297L86.882 292.988L87.2535 292.617Z",
    fill: "#576065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1029 244.271V246.689L80.0269 287.782C80.0269 288.339 80.2119 288.898 80.7686 289.269L83.1774 291.128L84.8446 245.759L85.0297 242.226C84.4731 242.598 84.288 243.341 84.1029 244.271Z",
    fill: "#A5ABAF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8791 291.872L79.6554 290.014L42.0417 317.347C42.0417 317.347 40.9298 318.092 40.7448 318.835L42.0417 318.09L81.5089 293.174C82.2506 292.802 82.4357 292.431 81.8791 291.872Z",
    fill: "#A5ABAF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7701 295.406C85.7701 295.22 85.585 295.034 85.3999 295.22L40.5597 320.693C41.6716 321.438 42.7835 321.623 44.2655 321.065L86.1416 304.144L85.7701 295.406Z",
    fill: "#576065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.067 292.803C87.067 292.803 87.067 292.988 87.2521 292.988H87.4372C87.6223 292.803 92.9953 290.014 94.8489 288.898L94.1072 283.506L88.364 244.271C88.364 243.527 88.1789 242.97 87.8087 242.598C87.8087 242.598 90.5878 280.159 90.5878 284.249C90.5878 289.642 87.067 292.803 87.067 292.803Z",
    fill: "url(#paint18_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7701 295.406C85.7701 295.22 85.585 295.034 85.3999 295.22L40.5597 320.693C41.6716 321.438 42.7835 321.623 44.2655 321.065L86.1416 304.144L85.7701 295.406Z",
    fill: "url(#paint19_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2655 320.88L86.1416 303.959L85.7714 295.777C85.0297 298.009 83.7327 300.426 80.2133 302.285C77.6194 303.772 52.7904 316.044 43.8967 320.321C43.3414 320.692 42.5997 320.878 42.2295 321.065C42.9685 321.438 43.5238 321.252 44.2655 320.88Z",
    fill: "url(#paint20_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2535 292.617L87.0684 292.803C87.0684 292.803 87.0684 293.174 87.4386 292.988C87.6236 292.803 92.9967 290.014 94.8502 288.898L88.364 244.271C88.1789 242.598 87.4372 241.854 86.1403 241.297L86.882 292.988L87.2535 292.617Z",
    fill: "url(#paint21_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2535 292.617L87.0684 292.803C87.0684 292.803 87.0684 293.174 87.4386 292.988C87.6236 292.803 92.9967 290.014 94.8502 288.898L88.364 244.271C88.1789 242.598 87.4372 241.854 86.1403 241.297L86.882 292.988L87.2535 292.617Z",
    fill: "url(#paint22_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4837 316.976C35.1867 314.001 27.7751 299.497 35.9284 271.606H32.7779C31.1107 277.184 29.8137 280.531 29.072 285.552C29.072 285.552 28.7019 287.411 28.5168 289.456C28.3317 291.502 28.3317 292.618 28.3317 293.92C28.3317 305.076 31.1107 311.584 31.1107 311.584C34.0749 320.88 39.2641 329.248 46.3042 335.57C52.4189 340.962 61.8693 345.054 69.6511 346.541C68.3528 346.354 46.1178 336.872 36.4837 316.976Z",
    fill: "url(#paint23_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0671 295.034H85.3999C85.585 295.034 85.7701 295.034 85.7701 295.22L86.1403 303.773H86.3254L86.6956 295.22C86.6969 295.034 86.882 294.848 87.0671 295.034Z",
    fill: "url(#paint24_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.856 238.694C124.312 246.132 142.655 266.585 142.655 292.431C142.655 323.669 117.826 349.144 86.3267 349.144V352.119C117.826 352.119 144.323 326.087 144.323 293.918C144.323 268.258 128.016 246.689 104.856 238.694Z",
    fill: "url(#paint25_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.985 271.977C123.014 242.04 93.7383 240.367 92.0699 240.181H91.8848C114.305 244.271 128.573 258.961 133.576 274.394V274.58C135.8 280.53 136.911 286.852 137.096 293.731C137.282 300.239 135.799 307.491 133.02 314.184C132.835 315.114 132.65 316.23 132.465 316.23H135.429C144.323 299.497 140.431 282.576 135.985 271.977Z",
    fill: "url(#paint26_linear_3_924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1094 294.104C31.1094 263.61 55.7532 238.507 86.3254 238.507C116.898 238.507 141.541 263.423 141.541 294.104C141.541 324.598 116.898 349.329 86.3254 349.329C55.7532 349.329 31.1094 324.599 31.1094 294.104ZM48.3416 255.8C38.521 265.655 32.4064 279.229 32.4064 294.104C32.4064 308.98 38.521 322.554 48.1565 332.223C57.977 341.892 71.5034 348.028 86.3267 348.028C101.15 348.028 114.676 342.078 124.312 332.223C134.132 322.554 140.062 308.98 140.062 294.104C140.062 279.229 133.947 265.655 124.312 255.8C114.676 245.944 101.15 239.81 86.3267 239.81C71.5034 239.81 57.977 245.946 48.3416 255.8Z",
    fill: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6716 317.719L79.4704 290.385C81.509 291.501 84.8434 292.988 85.2149 292.988C85.585 293.174 85.585 292.803 85.585 292.803L80.9524 288.898C80.3971 288.526 80.2107 287.968 80.2107 287.411L84.6583 242.598C84.4732 242.784 84.4732 243.156 84.2881 243.343C84.103 243.714 84.103 243.9 84.103 244.273L77.6181 289.085L42.0418 317.162C41.8567 317.347 41.6716 317.533 41.6716 317.719Z",
    fill: "#344048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.495 277.44H405.467C406.085 277.44 406.596 276.927 406.596 276.307V266.794C406.596 266.174 406.085 265.661 405.467 265.661H386.806C386.188 265.661 385.677 266.174 385.677 266.794V268.515C385.677 269.135 386.188 269.648 386.806 269.648H399.066C399.268 269.648 399.439 269.819 399.439 270.023V271.861C399.439 272.064 399.269 272.236 399.066 272.236H374.664C374.046 272.236 373.534 271.723 373.534 271.103V264.048C373.534 263.428 374.046 262.914 374.664 262.914H405.478C406.096 262.914 406.607 262.401 406.607 261.781V259.194C406.607 258.574 406.096 258.061 405.478 258.061H367.506C366.888 258.061 366.376 258.574 366.376 259.194V276.296C366.366 276.927 366.877 277.44 367.495 277.44ZM356.865 277.44H361.765C362.383 277.44 362.894 276.927 362.894 276.307V259.206C362.894 258.586 362.383 258.072 361.765 258.072H356.258C356.034 258.072 355.831 258.126 355.64 258.254L342.208 267.05C341.825 267.296 341.357 267.296 340.973 267.05L327.542 258.254C327.351 258.126 327.158 258.072 326.924 258.072H321.417C320.799 258.072 320.288 258.586 320.288 259.206V276.308C320.288 276.928 320.799 277.441 321.417 277.441H326.317C326.935 277.441 327.446 276.928 327.446 276.308V266.004C327.446 265.812 327.542 265.64 327.712 265.544C327.883 265.448 328.085 265.459 328.245 265.555L338.641 272.096C338.833 272.214 339.014 272.267 339.238 272.267H343.903C344.127 272.267 344.319 272.214 344.5 272.096L354.896 265.555C355.066 265.448 355.258 265.448 355.429 265.544C355.599 265.64 355.705 265.811 355.705 266.004V276.308C355.736 276.927 356.247 277.44 356.865 277.44ZM315.697 277.44H310.798C310.18 277.44 309.668 276.927 309.668 276.307V273.293C309.668 273.09 309.498 272.918 309.295 272.918H283.53C283.168 272.918 282.859 273.068 282.636 273.357L279.941 276.852C279.643 277.238 279.227 277.44 278.748 277.44H272.016C271.814 277.44 271.633 277.334 271.547 277.141C271.452 276.96 271.473 276.746 271.601 276.585L285.522 258.511C285.745 258.223 286.054 258.072 286.416 258.072H315.697C316.315 258.072 316.826 258.586 316.826 259.206V276.308C316.827 276.927 316.326 277.44 315.697 277.44ZM309.669 267.553V263.31C309.669 263.107 309.499 262.935 309.296 262.935H291.039C290.795 262.935 290.592 263.042 290.443 263.223L287.194 267.446C287.119 267.542 287.108 267.659 287.162 267.766C287.215 267.873 287.311 267.937 287.428 267.937H309.295C309.499 267.928 309.669 267.757 309.669 267.553ZM225.108 277.44H208.949C208.747 277.44 208.566 277.334 208.48 277.141C208.385 276.96 208.406 276.746 208.534 276.585L222.455 258.511C222.678 258.223 222.987 258.072 223.349 258.072H239.347C239.581 258.072 239.784 258.2 239.89 258.414C239.997 258.628 239.965 258.863 239.827 259.055L226.001 277.002C225.779 277.291 225.47 277.44 225.108 277.44ZM236.857 277.44H229.209C229.006 277.44 228.825 277.334 228.74 277.141C228.644 276.96 228.665 276.746 228.793 276.585L242.715 258.511C242.938 258.223 243.247 258.072 243.609 258.072H251.108C251.342 258.072 251.545 258.2 251.651 258.414C251.758 258.628 251.726 258.863 251.588 259.055L237.762 277.002C237.528 277.291 237.218 277.44 236.857 277.44ZM247.391 277.44H241.48C241.277 277.44 241.096 277.334 241.011 277.141C240.915 276.96 240.936 276.746 241.064 276.585L254.986 258.511C255.209 258.223 255.518 258.072 255.88 258.072H261.632C261.866 258.072 262.069 258.2 262.175 258.414C262.282 258.628 262.26 258.863 262.111 259.055L248.286 277.002C248.062 277.291 247.753 277.44 247.391 277.44ZM256.902 277.44H252.78C252.578 277.44 252.396 277.334 252.311 277.141C252.215 276.96 252.237 276.746 252.364 276.585L266.285 258.511C266.509 258.223 266.818 258.072 267.18 258.072H271.153C271.387 258.072 271.59 258.2 271.696 258.414C271.803 258.628 271.771 258.863 271.633 259.055L257.807 277.002C257.573 277.291 257.264 277.44 256.902 277.44ZM266.02 277.44H262.985C262.782 277.44 262.601 277.334 262.516 277.141C262.42 276.96 262.441 276.746 262.569 276.585L276.49 258.511C276.713 258.223 277.023 258.072 277.384 258.072H280.26C280.494 258.072 280.697 258.2 280.804 258.414C280.91 258.628 280.878 258.863 280.74 259.055L266.915 277.002C266.691 277.291 266.382 277.44 266.02 277.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.646 288.129C194.549 287.445 192.397 287.125 189.075 287.125H174.621V306.632H177.699V299.15H189.075C192.409 299.15 194.56 298.83 195.646 298.156C196.765 297.472 197.329 296.2 197.329 294.394V291.904C197.34 290.096 196.776 288.824 195.646 288.129ZM194.081 292.64V293.548C194.081 294.756 193.815 295.547 193.303 295.889C192.749 296.263 191.578 296.455 189.809 296.455H177.709V289.732H189.809C191.577 289.732 192.76 289.925 193.303 290.299C193.815 290.652 194.081 291.443 194.081 292.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.745 289.786H224.352V287.124H203.72V306.631H224.352V303.969H206.745V297.844H223.617V295.182H206.745V289.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.804 289.786H238.912V306.632H241.99V289.786H252.088V287.124H228.804L228.804 289.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.249 288.119C278.141 287.445 275.989 287.114 272.656 287.114H257.818V306.621H260.896V299.182H272.996C275.563 299.182 276.532 299.513 276.894 299.802C277.406 300.198 277.661 300.978 277.661 302.121V306.621H280.739V301.651C280.739 300.485 280.43 299.545 279.813 298.872C279.429 298.454 278.929 298.134 278.321 297.931C279.11 297.675 279.695 297.343 280.089 296.937C280.664 296.339 280.952 295.409 280.952 294.169V291.903C280.964 290.086 280.389 288.813 279.249 288.119ZM277.747 292.64V293.548C277.747 294.724 277.481 295.515 276.969 295.878C276.415 296.263 275.244 296.455 273.486 296.455H260.907V289.732H273.486C275.243 289.732 276.415 289.925 276.969 290.32C277.481 290.695 277.747 291.475 277.747 292.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.618 288.268C310.937 287.765 310.042 287.413 308.934 287.2C307.859 286.997 306.218 286.89 304.066 286.89H297.249C295.098 286.89 293.457 286.997 292.381 287.2C291.284 287.413 290.379 287.766 289.697 288.268C288.93 288.835 288.376 289.615 288.036 290.598C287.706 291.56 287.545 292.853 287.545 294.456V299.63C287.545 301.094 287.716 302.302 288.046 303.21C288.387 304.14 288.951 304.899 289.729 305.476C290.421 305.979 291.316 306.342 292.392 306.545C293.446 306.748 295.098 306.844 297.281 306.844H304.066C306.27 306.844 307.921 306.737 308.976 306.545C310.052 306.342 310.936 305.978 311.618 305.476C312.363 304.931 312.917 304.161 313.258 303.2C313.598 302.259 313.769 301.019 313.769 299.512V294.232C313.769 292.736 313.599 291.506 313.258 290.555C312.917 289.583 312.364 288.813 311.618 288.268ZM305.27 304.119H296.046C294.757 304.119 293.767 304.013 293.074 303.81C292.414 303.618 291.902 303.286 291.541 302.837C291.275 302.517 291.082 302.121 290.976 301.683C290.859 301.212 290.806 300.411 290.806 299.31V294.329C290.806 293.228 290.859 292.426 290.976 291.956C291.082 291.507 291.274 291.123 291.541 290.802C291.903 290.352 292.425 290.032 293.074 289.84C293.756 289.637 294.757 289.53 296.046 289.53H305.27C306.559 289.53 307.549 289.637 308.231 289.84C308.881 290.032 309.403 290.364 309.765 290.802C310.009 291.111 310.191 291.486 310.298 291.903C310.415 292.352 310.468 293.068 310.468 294.041V299.61C310.468 300.572 310.415 301.288 310.298 301.737C310.191 302.165 310.01 302.538 309.765 302.849C309.402 303.298 308.881 303.618 308.231 303.821C307.549 304.013 306.559 304.119 305.27 304.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.341 287.125H343.274V303.575L325.209 287.125H320.843V306.632H323.931V289.925L342.262 306.632H346.342L346.341 287.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.309 287.125L351.124 306.632H354.66L357.26 302.452H373.183L375.857 306.632H379.191L366.974 287.125H363.309ZM358.846 299.908L365.173 289.796L371.607 299.908H358.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.575 297.814C406.256 297.076 405.713 296.488 404.956 296.082C404.445 295.794 403.763 295.591 402.922 295.462C402.102 295.345 400.877 295.281 399.269 295.281H391.941C389.736 295.281 388.287 295.067 387.616 294.639C386.977 294.233 386.668 293.485 386.668 292.352C386.668 291.24 386.988 290.503 387.637 290.108C388.33 289.69 389.725 289.477 391.781 289.477H398.737C400.75 289.477 402.081 289.68 402.678 290.086C403.243 290.471 403.519 291.241 403.519 292.384V292.951H406.501V292.128C406.501 291.177 406.384 290.375 406.15 289.745C405.916 289.093 405.532 288.558 405.021 288.152C404.414 287.682 403.572 287.351 402.518 287.169C401.495 286.988 399.684 286.902 397.149 286.902H392.516C389.086 286.902 386.786 287.298 385.475 288.121C384.144 288.954 383.462 290.419 383.462 292.46C383.462 294.459 384.059 295.892 385.23 296.725C386.391 297.548 388.318 297.955 391.12 297.955H399.737C401.483 297.955 402.644 298.158 403.177 298.564C403.689 298.949 403.944 299.708 403.944 300.809C403.944 302.156 403.571 303.032 402.815 303.492C402.016 303.973 400.247 304.219 397.543 304.219H392.216C389.969 304.219 388.435 303.994 387.637 303.556C386.881 303.139 386.518 302.401 386.518 301.311C386.518 301.183 386.529 300.937 386.55 300.574L386.603 299.911H383.632L383.589 300.135C383.578 300.199 383.568 300.285 383.568 300.392C383.536 300.969 383.525 301.375 383.525 301.61C383.525 303.481 384.154 304.849 385.4 305.662C386.625 306.463 388.584 306.859 391.407 306.859H398.331C401.59 306.859 403.806 306.431 405.083 305.566C406.372 304.679 407.033 303.129 407.033 300.938C407.043 299.588 406.884 298.541 406.575 297.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.851 322.782V323.84H209.088V330.648H207.885V316.464H215.276V317.522H209.088V322.77H214.85V322.782H214.851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.763 323.541C229.763 327.859 227.473 330.873 224.234 330.873C220.911 330.873 218.664 327.87 218.664 323.456C218.664 319.244 220.996 316.23 224.213 316.23C227.473 316.23 229.763 319.256 229.763 323.541ZM219.963 323.477C219.963 327.196 221.699 329.794 224.202 329.794C226.684 329.794 228.442 327.196 228.442 323.541C228.442 319.907 226.685 317.309 224.202 317.309C221.753 317.31 219.963 319.907 219.963 323.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.345 316.466C238.528 316.466 239.168 316.53 240.094 316.851C241.553 317.321 242.469 318.658 242.469 320.357C242.469 322.228 241.457 323.499 239.423 324.183L243.3 330.65H241.819L238.028 324.354H235.396V330.65H234.193V316.466H236.345ZM236.388 323.285C238.252 323.285 238.72 323.242 239.434 322.986C240.531 322.601 241.148 321.65 241.148 320.324C241.148 319.116 240.594 318.218 239.668 317.834C238.986 317.578 238.421 317.514 236.408 317.514H235.396V323.275H236.387L236.388 323.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.201 316.466L253.462 329.292L257.722 316.466H259.672V330.65H258.468V317.578L254.08 330.65H252.876L248.466 317.578V330.65H247.262V316.466H249.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.764 316.466V324.889C265.785 327.444 265.828 327.828 266.297 328.48C266.851 329.314 267.99 329.795 269.343 329.795C270.866 329.795 272.08 329.196 272.581 328.202C272.9 327.582 272.922 327.23 272.944 324.889V316.466H274.147V324.91C274.147 327.229 274.126 327.508 273.871 328.224C273.274 329.902 271.602 330.886 269.334 330.886C267.299 330.886 265.755 330.095 265.03 328.716C264.668 328.01 264.54 327.315 264.54 325.947V316.466L265.764 316.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.271 316.466V329.581H286.289V330.638H279.025V316.454H280.271V316.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.269 316.358L300.168 330.649H298.901L297.526 326.63H292.105L290.709 330.649H289.463L294.363 316.358H295.269ZM294.8 318.079L292.425 325.561H297.154L294.8 318.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.023 323.541C321.023 327.859 318.734 330.873 315.495 330.873C312.172 330.873 309.924 327.87 309.924 323.456C309.924 319.244 312.257 316.23 315.474 316.23C318.734 316.23 321.023 319.256 321.023 323.541ZM311.235 323.477C311.235 327.196 312.971 329.794 315.474 329.794C317.955 329.794 319.713 327.196 319.713 323.541C319.713 319.907 317.956 317.309 315.474 317.309C313.014 317.31 311.235 319.907 311.235 323.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.775 316.466L333.89 328.886V316.466H335.009V330.65H333.614L326.584 318.272V330.65H325.444V316.466H326.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.066 322.782V323.84H341.303V329.58H347.577V330.638H340.1V316.453H347.492V317.511H341.303V322.759H347.066V322.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.684 316.466V317.523H362.041V330.638H360.838V317.523H357.174V316.466H365.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.399 322.782V323.84H370.637V329.58H376.911V330.638H369.434V316.453H376.826V317.511H370.637V322.759H376.399V322.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.655 316.358L390.555 330.649H389.287L387.913 326.63H382.492L381.096 330.649H379.85L384.749 316.358H385.655ZM385.187 318.079L382.812 325.561H387.542L385.187 318.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.243 316.466L400.504 329.292L404.764 316.466H406.713V330.65H405.51V317.578L401.121 330.65H399.918L395.508 317.578V330.65H394.304V316.466H396.243Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_924",
    x1: 900.323,
    y1: 136.714,
    x2: 220.425,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_924",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.393,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_924",
    x1: 64.8379,
    y1: 608.483,
    x2: 513.999,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_924",
    x1: 360.898,
    y1: 964.812,
    x2: 866.563,
    y2: 444.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_924",
    x1: 276.23,
    y1: 500.057,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_924",
    x1: 200.656,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_924",
    x1: -97.0263,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_924",
    x1: -214.997,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_924",
    x1: 20.1718,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_924",
    x1: 560.964,
    y1: 452.869,
    x2: 185.719,
    y2: 876.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3_924",
    x1: -34.4468,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3_924",
    x1: -52.7464,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3_924",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3138,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#80142C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3_924",
    x1: 41.8909,
    y1: 256.509,
    x2: 197.091,
    y2: 386.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CED0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A6ACAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#98A0A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#828A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#677176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#545D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#485259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#444E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#485258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3_924",
    x1: 44.5889,
    y1: 258.72,
    x2: 190.09,
    y2: 380.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F1F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#344048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81898E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B3B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEE0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3_924",
    x1: 106.616,
    y1: 349.844,
    x2: 35.5711,
    y2: 155.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E3E1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1C5C4",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9BA0A2",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7E8588",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#697174",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5C656A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586166",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3_924",
    x1: 60.8165,
    y1: 249.466,
    x2: 150.226,
    y2: 403.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E3E1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1C5C4",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9BA0A2",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7E8588",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#697174",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5C656A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586166",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3_924",
    x1: 109.442,
    y1: 307.693,
    x2: 103.933,
    y2: 316.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27353D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1620",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3_924",
    x1: 100.327,
    y1: 288.568,
    x2: 91.2543,
    y2: 274.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0B1721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0B1721",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1721",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3_924",
    x1: 86.2644,
    y1: 302.01,
    x2: 72.7229,
    y2: 305.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1721",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0B1721",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0B1721",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1721",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3_924",
    x1: 65.5713,
    y1: 312.354,
    x2: 63.6251,
    y2: 307.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1721",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0B1721",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1721",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3_924",
    x1: 92.9703,
    y1: 266.457,
    x2: 82.0077,
    y2: 267.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0B1721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0B1721",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1721",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3_924",
    x1: 93.1976,
    y1: 266.351,
    x2: 85.7815,
    y2: 267.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27353D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27353D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C484F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3_924",
    x1: 26.4134,
    y1: 295.436,
    x2: 116.477,
    y2: 347.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26333C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#27353D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27353D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3_924",
    x1: 86.2328,
    y1: 303.963,
    x2: 86.2328,
    y2: 288.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6ACB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A6ACB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6ACB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3_924",
    x1: 115.291,
    y1: 238.679,
    x2: 115.291,
    y2: 436.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#344048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#27353D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#344048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444E55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3_924",
    x1: 133.213,
    y1: 249.492,
    x2: 89.4801,
    y2: 313.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27353D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4A555C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 119,
    fill: "white",
    transform: "translate(27 234)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMenuMercedes);
export default __webpack_public_path__ + "static/media/team_menu_mercedes.5250af4a0d0fc1102ad7b2117a145773.svg";
export { ForwardRef as ReactComponent };